import { ArrowRight, Building2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useLocalePath, useTranslation } from "@thyra/landing-i18n";

/**
 * Slim homepage band pointing business buyers to the dedicated /business
 * page (Notion/Slack pattern: consumer-first home, enterprise on its own
 * page).
 */
export function ForBusinessTeaser() {
  const { t } = useTranslation("sections");
  const lp = useLocalePath();
  return (
    <section className="py-6 sm:py-8">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="marketing-card marketing-card-hover flex flex-col gap-6 p-6 sm:p-8 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-4">
            <span className="hidden h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 sm:flex">
              <Building2 className="h-5 w-5 text-primary" strokeWidth={2} />
            </span>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-primary">
                {t("forBusinessTeaser.eyebrow")}
              </p>
              <h2 className="mt-1 text-xl font-semibold tracking-tight text-card-foreground sm:text-2xl">
                {t("forBusinessTeaser.title")}
              </h2>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">
                {t("forBusinessTeaser.description")}
              </p>
            </div>
          </div>
          <Link
            to={lp("/business")}
            className="btn-brand group inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-xl px-6 text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
          >
            {t("forBusinessTeaser.cta")}
            <ArrowRight
              className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
              strokeWidth={2}
            />
          </Link>
        </div>
      </div>
    </section>
  );
}
